import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/btch/excutn`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/btch/excutn`,
    nodes: [],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    ptli1203001q: `${BASE.path}/ptli1203001q`, // Managing batch runs list !== 배치실행관리 목록 ==!
    ptli1203002s: `${BASE.path}/ptli1203002s`, // Managing batch runs Details !== 배치실행관리 상세 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // Select the batch execution management list !== 배치 실행 관리 목록 조회 ==!
    getBtchExcutnList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Select batch execution details !== 배치 실행 정보 조회 ==!
    getBtchExcutnInfo: (btchId: any) => api.get(`${BASE.api}/${btchId}`),

    // Execute batch !== 배치 실행 ==!
    executeBtch: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    // Pause batch !== 배치 중지 ==!
    pauseBtch: (data: any) => {
        return api.post(`${BASE.api}/pause`, {
            ...data,
        });
    },
    // Resume batch !== 배치 재실행 ==!
    resumeBtch: (data: any) => {
        return api.post(`${BASE.api}/resume`, {
            ...data,
        });
    },
};

export const SF_BTCH_EXCUTN_SEARCH_FORM: TFormSchema = {
    id: "form_excutnSrch",
    schema: {
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_NM",
            all: true,
            area: "comnCd",
            comnCd: "COM0024",
            excludes: ["TDW", "TDA"],
        } /* Business Type !== 업무구분 ==!*/,
        btchNm: {
            type: "text",
            label: "L_BTCH_NM",
            edit: true,
        } /* Batch Name !== 배치명 ==!*/,
    },
};

export const SF_BTCH_EXCUTN_FORM: TFormSchema = {
    id: "form_excutnSrch",
    schema: {
        btchId: {
            type: "text",
            label: "L_BTCH_ID",
            edit: true,
        } /* Batch ID !== 배치 ID ==!*/,
        btchNm: {
            type: "text",
            label: "L_BTCH_NM",
            edit: true,
        } /* Job Name(Barch Name) !== Job 이름(배치명) ==!*/,
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_NM",
            edit: true,
            area: "comnCd",
            comnCd: "COM0024",
        },
    },
};

export const SG_BTCH_EXCUTN_LIST: TGridSchema = {
    id: "grid_btchInfoList",
    options: { pagination: "out", edit: false, checkbox: false, radio: false, index: true },
    head: [
        { cells: [{ header: "L_BTCH_ID", binding: "btchId", width: "22%" }], id: "btchId" },
        { cells: [{ header: "L_BTCH_NM", binding: "btchNm", width: "*" }], id: "btchNm" },
        { cells: [{ header: "L_BSOP_CLSF_NM", binding: "bsopClsfCdNm", width: "15%" }], id: "bsopClsfCdNm" },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "15%" }], id: "frstRgsrDtm" },
        { cells: [{ header: "L_LAST_MDFY_DTM", binding: "lastMdfyDtm", width: "15%" }], id: "lastMdfyDtm" },
        { cells: [{ header: "L_EXCUTN", binding: "excutn", width: 90 }], id: "excutn" },
    ],
    body: [
        {
            cells: [{ binding: "btchId" }] /* Batch ID !== 배치 ID ==!*/,
        },
        {
            cells: [{ binding: "btchNm", align: "left" }] /* Job Name(Barch Name) !== Job 이름(배치명) ==!*/,
        },
        {
            cells: [{ binding: "bsopClsfCdNm" }] /* Business Type !== 업무 구분 ==!*/,
        },
        {
            cells: [{ binding: "frstRgsrDtm", type: "datetime" }] /* Registration Date !== 등록 일자 ==!*/,
        },
        {
            cells: [{ binding: "lastMdfyDtm", type: "datetime" }] /* Last Modify Date !== 최종 수정 일자 ==!*/,
        },
        {
            cells: [{ binding: "excutn" }] /* Execute !== 실행 ==!*/,
        },
    ],
};

export const SG_BTCH_EXCUTN_PRMT_LIST: TGridSchema = {
    id: "grid_btchExcutnPrmtList",
    options: { pagination: "in", edit: true, checkbox: false, radio: false, index: false },
    head: [
        { cells: [{ header: "L_PRMT_NM", binding: "btchPrmtNm", width: "*" }], id: "btchPrmtNm" },
        { cells: [{ header: "L_PRMT", binding: "btchPrmtValue", width: "*" }], id: "btchPrmtValue" },
    ],
    body: [
        {
            cells: [{ binding: "btchPrmtNm" }] /* Parameter Name !== 파라미터명 ==!*/,
        },
        {
            cells: [{ binding: "btchPrmtValue" }] /* Parameter !== 파라미터 ==!*/,
        },
    ],
};
